import { combineReducers } from 'redux'
import commonReducer from 'redux/modules/common'
import searchReducer from 'redux/modules/search'
import auctionReducer from 'redux/modules/auction'

export default combineReducers({
  common: commonReducer,
  search: searchReducer,
  auction: auctionReducer,
})
